import "./ResidencePermit.scss";
import InfoContext from "pages/InfoContext";
import InputDate from "core/inputs/input-date/InputDate";
import InputSelect from "core/inputs/input-select/InputSelect";
import InputText from "core/inputs/input-text/InputText";
import { Controller } from "utils/Controller";
import { FormattedMessage } from "react-intl";
import { Typography } from "core/typography/Typography";
import { VISA_TYPES } from "constants/forms";
import { useContext, useEffect } from "react";
import PropTypes from "prop-types";

const ResidencePermitForm = ({
  readOnly,
  isVisa,
  control,
  register,
  setValue,
  labels,
  placeholders,
  showSection,
  setShowSection,
  watch,
}) => {
  const { lang } = useContext(InfoContext);
  const visaType = watch("visa_type");

  useEffect(() => {
    setShowSection(isVisa);
  }, [isVisa]);

  useEffect(() => {
    if (!visaType) {
      setValue("visa_expiration_date", null);
      setValue("visa_number", null);
      setValue("visa_status", "");
    }
  }, [visaType]);

  const formFields = [
    {
      name: "visa_type",
      render: (props) => (
        <InputSelect
          id="visa_type"
          label={labels.visa_type}
          options={[{ value: null, label: "" }, ...VISA_TYPES]}
          readOnly={readOnly}
          setValue={setValue}
          maxHeight={160}
          {...props}
        />
      ),
    },
    {
      name: "visa_expiration_date",
      render: () => (
        <InputDate
          id="visa_expiration_date"
          label={labels.visa_expiration_date}
          readOnly={readOnly}
          lang={lang}
          onChange={(e) => {
            setValue("visa_expiration_date", e.target.value);
          }}
          value={watch("visa_expiration_date")}
        />
      ),
    },
    {
      name: "visa_number",
      render: (props) => (
        <InputText
          label={labels.visa_number}
          placeholder={placeholders.visa_number}
          readOnly={readOnly}
          maxLength={10}
          {...props}
        />
      ),
    },
  ];

  return (
    <div className="section-2">
      <div className="buttons-group">
        {!isVisa && !readOnly ? (
          <div
            aria-pressed="false"
            tabIndex={0}
            role="button"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setValue("visa_type", null);
              setValue("visa_expiration_date", null);
              setValue("visa_number", null);
              setValue("visa_status", "");
              setShowSection(!showSection);
            }}
          >
            <Typography
              className="link-1 violet "
              type="h2"
              label={
                <>
                  +{" "}
                  <FormattedMessage
                    id="input_visa_label"
                    defaultMessage="Ajouter un titre de séjour"
                  />
                </>
              }
            />
          </div>
        ) : (
          showSection && (
            <Typography
              className="text violet "
              type="h2"
              label={
                <FormattedMessage
                  id="input_visa_display_label"
                  defaultMessage="Titre de séjour"
                />
              }
            />
          )
        )}

        {showSection && !readOnly && !isVisa && (
          <div
            aria-pressed="false"
            tabIndex={0}
            role="button"
            style={{ cursor: "pointer" }}
            onClick={() => setShowSection(false)}
          >
            <Typography
              className="link-2 violet "
              type="h2"
              label={<FormattedMessage id="close" defaultMessage="Fermer" />}
            />
          </div>
        )}
      </div>

      {showSection && (
        <div className="residence-permit__section">
          {formFields.map((field, index) => (
            <div className="cell-padding" key={index}>
              <Controller
                control={control}
                register={register}
                name={field.name}
                render={field.render}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ResidencePermitForm;

ResidencePermitForm.propTypes = {
  readOnly: PropTypes.bool,
  isVisa: PropTypes.bool,
  control: PropTypes.object,
  register: PropTypes.func,
  setValue: PropTypes.func,
  labels: PropTypes.object,
  placeholders: PropTypes.object,
  showSection: PropTypes.bool,
  setShowSection: PropTypes.func,
};
